"use client";

import { Component } from "react";
import loadScript from "load-script";
import { StoreContext } from "../../stores/StoreContext";
import { getConfig } from "../../_configs/AppConfig";
import { AppContextType } from "../../stores/StoreLoader";
import ErrorBlock from "../blocks/SchoolBlocks/ErrorBlock";
const { publicRuntimeConfig } = getConfig();

function MeritChatFallback({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 15,
        minHeight: "inherit",
        height: "inherit",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <ErrorBlock blockObj={{ errorMessage: message }} />
    </div>
  );
}

export class MeritChat<P = {}, S = {}> extends Component<
  P,
  S & { loadFailed?: boolean }
> {
  static contextType = StoreContext;

  state = { loadFailed: false } as S & { loadFailed?: boolean };

  loginFunction = (): void => {
    const { modalStore } = this.context as AppContextType;
    modalStore.addModal({
      type: "login",
      size: "lg",
      id: "login-modal",
    });
  };

  onLoaded = (err?: Error | null) => {
    const { organizationStore } = this.context as AppContextType;
    if (!err && typeof MC !== "undefined") {
      MC.hostname = publicRuntimeConfig.MERITCHAT_API_URL.replace(
        "https://",
        "",
      );
      MC.reactInit(
        organizationStore.currentOrganization.mcauth as string,
        this.loginFunction,
      );
    } else {
      this.setState({ loadFailed: true } as S & { loadFailed?: boolean });
    }
  };

  componentDidMount() {
    if (typeof MC === "undefined") {
      loadScript(
        `${publicRuntimeConfig.MERITCHAT_API_URL}/meritchat.js`,
        this.onLoaded,
      );
    }
  }
}

export class MeritChatThreadHeader extends MeritChat<{
  source_id: number;
  source_category: string;
  organization_id: string;
  language: string;
}> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat thread-header"
        data-source-id={this.props.source_id}
        data-organization-id={this.props.organization_id}
        data-source-category={this.props.source_category}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
        data-translate-from={this.props.language.split("-")[0]}
      />
    );
  }
}

export class MeritChatThread extends MeritChat<
  {
    source_id: number;
    source_category: string;
    organization_id: string;
    language: string;
  },
  any
> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <div
        className="meritchat thread"
        data-source-id={this.props.source_id}
        data-organization-id={this.props.organization_id}
        data-source-category={this.props.source_category}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
        data-translate-from={this.props.language.split("-")[0]}
      />
    );
  }
}

export class MeritChatOrgReport extends MeritChat<
  {
    organization_id: string;
  },
  any
> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    if (this.state.loadFailed) {
      return (
        <MeritChatFallback message="There was an issue loading the MeritChat Organization Report." />
      );
    }

    return (
      <div
        className="meritchat orgreport"
        data-source-org={this.props.organization_id}
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      />
    );
  }
}

export class MeritChatModeratorMenu extends MeritChat {
  render() {
    const { i18nStore } = this.context as AppContextType;

    if (this.state.loadFailed) {
      return (
        <MeritChatFallback message="There was an error loading the moderation widget." />
      );
    }

    return (
      <div
        className="meritchat moderator single"
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      />
    );
  }
}

export class MeritChatThreadCTA extends MeritChat<{}, any> {
  render() {
    const { i18nStore } = this.context as AppContextType;

    return (
      <span
        className="meritchat thread-cta"
        data-source-id="1"
        data-source-category="custom.news"
        data-translate={i18nStore.currentAppSupportedLocale.split("-")[0]}
      ></span>
    );
  }
}
